import { IMAGES_CDN_URL } from "@/config/constants.ts";
import { EventCategory } from "@/types/ui";

export type MapAssetPair = { uncompressed: string; compressed: string };

/** Seasonal eventium toast/UI icons — must be loaded before collect toasts render */
export const EVENTIUM_ICON_ASSETS: Record<EventCategory, MapAssetPair> = {
	[EventCategory.CHRISTMAS]: {
		uncompressed: `${IMAGES_CDN_URL}/events/christmas/icons/eventium-184.avif`,
		compressed: `${IMAGES_CDN_URL}/events/christmas/icons/eventium-184.pvr`,
	},
	[EventCategory.FIREFEST]: {
		uncompressed: `${IMAGES_CDN_URL}/events/firefest/icons/eventium-184.avif`,
		compressed: `${IMAGES_CDN_URL}/events/firefest/icons/eventium-184.pvr`,
	},
	[EventCategory.FISHING]: {
		uncompressed: `${IMAGES_CDN_URL}/events/fishing/icons/eventium-184.avif`,
		compressed: `${IMAGES_CDN_URL}/events/fishing/icons/eventium-184.pvr`,
	},
	[EventCategory.EASTER]: {
		uncompressed: `${IMAGES_CDN_URL}/events/easter/icons/eventium-184.avif?v2`,
		compressed: `${IMAGES_CDN_URL}/events/easter/icons/eventium-184.pvr`,
	},
	[EventCategory.SOLAR]: {
		uncompressed: `${IMAGES_CDN_URL}/events/solarfair/icons/eventium-184.avif`,
		compressed: `${IMAGES_CDN_URL}/events/solarfair/icons/eventium-184.pvr`,
	},
	[EventCategory.HUNTING]: {
		uncompressed: `${IMAGES_CDN_URL}/events/hunting/icons/eventium-184.avif`,
		compressed: `${IMAGES_CDN_URL}/events/hunting/icons/eventium-184.pvr`,
	},
	[EventCategory.HALLOWEEN]: {
		uncompressed: `${IMAGES_CDN_URL}/events/halloween/icons/eventium-184.avif`,
		compressed: `${IMAGES_CDN_URL}/events/halloween/icons/eventium-184.pvr`,
	},
	[EventCategory.PIRATES]: {
		uncompressed: `${IMAGES_CDN_URL}/events/pirates/icons/eventium-184.avif`,
		compressed: `${IMAGES_CDN_URL}/events/pirates/icons/eventium-184.pvr`,
	},
};

export function eventiumIconKeyForType(
	type: string | null | undefined,
): string | null {
	if (type === EventCategory.CHRISTMAS) return "icon-christmas-eventium";
	if (type === EventCategory.FIREFEST) return "icon-firefest-eventium";
	if (type === EventCategory.EASTER) return "icon-easter-eventium";
	if (type === EventCategory.FISHING) return "icon-fishing-eventium";
	if (type === EventCategory.SOLAR) return "icon-solarfair-eventium";
	if (type === EventCategory.HUNTING) return "icon-hunting-eventium";
	if (type === EventCategory.HALLOWEEN) return "icon-halloween-eventium";
	if (type === EventCategory.PIRATES) return "icon-pirates-eventium";

	return null;
}

export function getEventiumIconAssetsForType(
	type: string | null | undefined,
): Record<string, MapAssetPair> {
	const key = eventiumIconKeyForType(type);
	if (!key) return {};
	return { [key]: EVENTIUM_ICON_ASSETS[type as EventCategory] };
}
